import React, { forwardRef } from 'react'
import { Box, Typography } from '@mui/material'
import {
  Cancel,
  CheckCircle,
  DataSaverOff,
  ErrorOutline,
  Flag,
  InsertChart,
} from '@mui/icons-material'

const typeColorsAndIcons = {
  basic: {
    icon: <Flag />,
    iconColor: '#3498DB',
    backgroundColor: '#fff',
    fontColor: '#495057',
    borderColor: '#fff',
  },
  donut: {
    icon: <DataSaverOff />,
    iconColor: '#3498DB',
    backgroundColor: '#fff',
    fontColor: '#495057',
    borderColor: '#fff',
  },
  data: {
    icon: <InsertChart />,
    iconColor: '#3498DB',
    backgroundColor: '#fff',
    fontColor: '#495057',
    borderColor: '#fff',
  },
  success: {
    icon: <CheckCircle />,
    iconColor: '#60BE64',
    backgroundColor: '#F2FBF1',
    fontColor: '#165719',
    borderColor: '#165719',
  },
  error: {
    icon: <Cancel />,
    iconColor: '#FD5C70',
    backgroundColor: '#FBF1F1',
    fontColor: '#962626',
    borderColor: '#962626',
  },
  warning: {
    icon: <ErrorOutline />,
    iconColor: '#FD5C70',
    backgroundColor: '#fff',
    fontColor: '#495057',
    borderColor: '#fff',
  },
}

const ValuePoint = forwardRef(
  (
    {
      text = 'Value Point',
      type = 'basic',
      sx = {},
      isTooltip = false,
      ...props
    },
    ref
  ) => {
    return (
      <Box
        ref={ref}
        display="flex"
        alignItems="center"
        gap="4px"
        p="6px 8px"
        mt={1}
        sx={{
          backgroundColor: typeColorsAndIcons[type]?.backgroundColor || '#fff',
          color: typeColorsAndIcons[type]?.fontColor || '#495057',
          border: `1px solid ${
            typeColorsAndIcons[type]?.borderColor || '#fff'
          }`,
          borderRadius: '22px',
          width: 'fit-content',
          cursor: isTooltip ? 'pointer' : 'default',
          '&>svg': {
            color: typeColorsAndIcons[type]?.iconColor || '#3498DB',
          },
          ...sx,
        }}
        {...props}
      >
        {typeColorsAndIcons[type]?.icon}
        <Typography variant="valuePoint">{text}</Typography>
      </Box>
    )
  }
)

ValuePoint.displayName = 'ValuePoint'

export default ValuePoint
